import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StatusScreenWrapper from "../components/StatusScreenWrapper";
import MainTitle from "../components/MainTitle";



const PaymentSuccess = () => {

    const location = useLocation();

    const navigate = useNavigate();

    const [renderResult, setRenderResult] = useState(false);

    // Esta función te ayuda a extraer los parámetros de la URL
    const getQueryParams = (search) => {
        return new URLSearchParams(search);
    };

    const queryParams = getQueryParams(location.search);

    // Ejemplo de cómo obtener algunos parámetros
    // const collectionId = queryParams.get("collection_id");
    const paymentId = queryParams.get("payment_id");
    console.log("Payment ID", paymentId);
    // const status = queryParams.get("status");
    // const externalReference = queryParams.get("external_reference");

    return (
        <div className="min-h-screen bg-[#f6f6ee] pb-10">

            {/* Header */}
            <MainTitle />

            {/* Comprobante de Mercado Pago */}
            <StatusScreenWrapper payment_id={paymentId} setRenderResult={setRenderResult}/>

            {renderResult && (
                <div className="px-4 mt-4">
                    <button
                        onClick={() => navigate(`/purchase/success/${paymentId}`)}
                        className="w-full py-3 rounded-xl text-sm font-semibold bg-[#2f5a2e] hover:bg-[#3f7a3a] active:scale-[0.98] text-[#f4f3e6] shadow-md shadow-[#2f5a2e]/20 transition-all duration-150"
                    >
                        Continuar →
                    </button>
                </div>
            )}
        </div>
    );
}

export default PaymentSuccess;
